<script>

    import { onMount } from 'svelte';
    let dev_collapsible_elem;    
    onMount(() => { M.Collapsible.init(dev_collapsible_elem)}); 

</script>

<div id="dev-stack" class="section">
    
    <ul class="collapsible" bind:this={dev_collapsible_elem}>
        <li>
            <div class="collapsible-header">
                <div class="pulse-blob">
                    <!-- <i class="material-icons cog">settings</i></div> -->
                    <i class="material-icons cog"><img id="dev-stack-button" src="/media/icons/material-icons/outline_settings_black_24dp.png" alt="outline settings icon - LFCamacho"></i></div>
                </div>
            <div class="collapsible-body container">
                <code> 
                    <p><span class="title strong">END-TO-END</span> <span class="subtitle strong">Serverless Full-Stack</span></p>
                    <p class="frontend strong">FRONTEND:</p>
                    <ul class="tech-list">
                        <li>— Svelte</li>
                        <li>— Materialize CSS</li>
                        <li>— Cloudflare Pages (CDN) / Github</li>
                    </ul>
                    <p class="backend strong">BACKEND:</p>
                    <ul class="tech-list">
                        <li>— Cloudflare Workers</li>
                        <li>— Cloudflare Turnstile Bot Challenge</li>
                        <li>— MailChannels Email Services</li>
                    </ul>                    
                </code>
            </div>
        </li>
    </ul>
    
</div>

<style>
    #dev-stack {
        background-color: #000000a8;;
        margin: 0;
        padding: 0;
    }
    #dev-stack .collapsible {
        border: none !important;
        margin: 0;
    }
    #dev-stack .collapsible-header {
        justify-content: center;
        background-color: transparent;
        border-bottom: none;
        padding: 0;
        position: relative;
    }
    #dev-stack .collapsible-header i {
        width: auto;
        margin-right: 0;
        background-color: #efebe9;
        border-radius: 25px;
        padding: 0;
        position: absolute;
        display: flex;
        justify-content: center;
    align-items: center;
        /* top: -11px; */
        /* top: -2px;
        left: -2.5px; */
    }

    .collapsible-body.container { 
        border: none;
        color: #b1b1b1;
        font-size: 12px !important;
    }

    code p { line-height: 1em; }

    .cog { animation: rotation 8s infinite linear; }

    .pulse-blob {
        background: black;
        border-radius: 50%;
        /* margin: 10px; */
        height: 20px;
        width: 20px;
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
        transform: scale(1);
        animation: pulse 2s infinite;
        top: -10px;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.85);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
        }

        100% {
            transform: scale(0.85);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        }
    }


    @keyframes rotation {
        from { transform: rotate(0deg);  }
        to { transform: rotate(359deg);  }
    }

    
    .title{ 
        color: #000;
        background-color: #68b15f;
        padding: 0 5px;
    }
    
    .subtitle {color: #68b15f; }
    
    .tech-list{ margin-left: 14px; }
    
    @media screen and (max-width: 600px) {
        .tech-list{ margin-left: 0px !important; }
    }


</style>